import { useParams } from 'react-router-dom';
import { InvoiceDetailView } from '../components/invoice-detail/InvoiceDetailView';

export function InvoiceDetailPage() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <>
        <div className="flex-1 flex items-center justify-center text-slate-400">
          <p className="text-sm">Geen factuur geselecteerd</p>
        </div>
      </>
    );
  }

  return (
    <>
      <InvoiceDetailView invoiceId={id} variant="page" />
    </>
  );
}
